import React from 'react';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';

// Auth Components
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginScreen from './components/LoginScreen';
import ResetPasswordForm from './components/auth/ResetPasswordForm';
import TrocarSenhaObrigatoria from './pages/Auth/TrocarSenhaObrigatoria';
import ForgotPasswordPage from './pages/Auth/ForgotPasswordPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import InactivityWarningModal from './components/InactivityWarningModal';

// Layout Components
import BaseLayout from './components/BaseLayout';

// Pages
import ProtocolosList from './pages/Protocolos/ProtocolosList';
import ProtocoloCreate from './pages/Protocolos/ProtocoloCreate';
import ProtocoloEdit from './pages/Protocolos/ProtocoloEdit';
import CursosList from './pages/Cursos/CursosList';
import CursoCreate from './pages/Cursos/CursoCreate';
import CursoEdit from './pages/Cursos/CursoEdit';
import AlunosList from './pages/Alunos/AlunosList';
import AlunoCreate from './pages/Alunos/AlunoCreate';
import AlunoEdit from './pages/Alunos/AlunoEdit';
import DocumentosPendentes from './pages/Alunos/DocumentosPendentes';
import ColaboradoresList from './pages/Colaboradores/ColaboradoresList';
import ColaboradorCreate from './pages/Colaboradores/ColaboradorCreate';
import ColaboradorEdit from './pages/Colaboradores/ColaboradorEdit';
import ContasList from './pages/Contas/ContasList';
import ContaCreate from './pages/Contas/ContaCreate';
import ContaEdit from './pages/Contas/ContaEdit';

// Funcionários
import FuncionariosList from './pages/Funcionarios/FuncionariosList';
import FuncionarioCreate from './pages/Funcionarios/FuncionarioCreate';
import FuncionarioEdit from './pages/Funcionarios/FuncionarioEdit';

// Pedidos
import PedidosList from './pages/Pedidos/PedidosList';
import PedidoCreate from './pages/Pedidos/PedidoCreateNew';
import PedidoEdit from './pages/Pedidos/PedidoEditNew';
import GerenciarSolicitacoesCancelamento from './pages/Pedidos/GerenciarSolicitacoesCancelamento';

// Estoque
import EntradaMaterialList from './pages/Estoque/Entrada/EntradaMaterialList';
import EntradaMaterialCreate from './pages/Estoque/Entrada/EntradaMaterialCreate';
import EntradaMaterialEdit from './pages/Estoque/Entrada/EntradaMaterialEdit';
import EstoqueDashboard from './components/EstoqueDashboard';
import EstoqueRelatorio from './pages/Estoque/EstoqueRelatorio';

// Produtos
import ProdutoList from './pages/Produto/ProdutoList';
import ProdutoCreate from './pages/Produto/ProdutoCreate';
import ProdutoEdit from './pages/Produto/ProdutoEdit';
import ProdutoPrecosCustomizados from './pages/Produtos/ProdutoPrecosCustomizados';

// Tipo Produto
import TipoProdutoList from './pages/TipoProduto/TipoProdutoList';
import TipoProdutoCreate from './pages/TipoProduto/TipoProdutoCreate';
import TipoProdutoEdit from './pages/TipoProduto/TipoProdutoEdit';

// Forma Entrega
import FormaEntregaList from './pages/FormaEntrega/FormaEntregaList';
import FormaEntregaCreate from './pages/FormaEntrega/FormaEntregaCreate';
import FormaEntregaEdit from './pages/FormaEntrega/FormaEntregaEdit';

// Forma Pagamento
import FormaPagamentoList from './pages/FormaPagamento/FormaPagamentoList';
import FormaPagamentoCreate from './pages/FormaPagamento/FormaPagamentoCreate';
import FormaPagamentoEdit from './pages/FormaPagamento/FormaPagamentoEdit';

// Prazo Entrega
import PrazoEntregaList from './pages/PrazoEntrega/PrazoEntregaList';
import PrazoEntregaCreate from './pages/PrazoEntrega/PrazoEntregaCreate';
import PrazoEntregaEdit from './pages/PrazoEntrega/PrazoEntregaEdit';

// Extensões
import ExtensoesList from './pages/Extensoes/ExtensoesList';
import ExtensaoCreate from './pages/Extensoes/ExtensaoCreate';
import ExtensaoEdit from './pages/Extensoes/ExtensaoEdit';

// Financeiro - Contas a Pagar
import ContasPagarList from './pages/Financeiro/ContasPagar/ContasPagarList';
import ContaPagarCreate from './pages/Financeiro/ContasPagar/ContaPagarCreate';
import ContaPagarEdit from './pages/Financeiro/ContasPagar/ContaPagarEdit';
import ContaPagarView from './pages/Financeiro/ContasPagar/ContaPagarView';

// Financeiro - Despesas
import DespesasList from './pages/Financeiro/Despesas/DespesasList';
import DespesaCreate from './pages/Financeiro/Despesas/DespesaCreate';
import DespesaEdit from './pages/Financeiro/Despesas/DespesaEdit';
import DespesaView from './pages/Financeiro/Despesas/DespesaView';

// Financeiro - Receitas
import ReceitasList from './pages/Financeiro/Receitas/ReceitasList';
import ReceitaCreate from './pages/Financeiro/Receitas/ReceitaCreate';
import ReceitaEdit from './pages/Financeiro/Receitas/ReceitaEdit';
import ReceitaView from './pages/Financeiro/Receitas/ReceitaView';

// Acadêmico - Matrículas
import MatriculasList from './pages/MatriculasList';
import ImprimirCredenciais from './pages/Matriculas/ImprimirCredenciais';

// Acadêmico - Histórico

// Acadêmico - Notas
import LancamentoNotas from './pages/Academico/LancamentoNotas';
import LancamentoNotasIndividual from './pages/Academico/LancamentoNotasIndividual';
import HistoricoNotas from './pages/Academico/HistoricoNotas';
import TransferenciaNotas from './pages/Academico/TransferenciaNotas';

// Acadêmico - Matriz Curricular
import MatrizCurricularList from './pages/Academico/MatrizCurricular/MatrizCurricularList';
import MatrizCurricularForm from './pages/Academico/MatrizCurricular/MatrizCurricularForm';
import MatrizCurricularEdit from './pages/Academico/MatrizCurricular/MatrizCurricularEdit';
import AlunoProgressoView from './pages/Academico/MatrizCurricular/AlunoProgressoView';
import MeuProgressoRedirect from './pages/Academico/MatrizCurricular/MeuProgressoRedirect';

// Profile
import MeuPerfil from './pages/Profile/MeuPerfil';

// Notificações
import NotificacoesPage from './pages/Notificacoes/NotificacoesPage';

// Agendamentos WhatsApp
import AgendamentosWhatsAppPage from './pages/AgendamentosWhatsApp/AgendamentosWhatsAppPage';

// Mural de Notícias
import { MuralNoticias, NoticiaView, GerenciarNoticias, NoticiaForm } from './pages/Mural';

// Segurança - Usuários
import UsuariosList from './pages/Seguranca/Usuarios/UsuariosList';
import UsuarioCreate from './pages/Seguranca/Usuarios/UsuarioCreate';
import UsuarioEdit from './pages/Seguranca/Usuarios/UsuarioEdit';
import UsuarioView from './pages/Seguranca/Usuarios/UsuarioView';
import UsuarioExtensaoAccess from './pages/Seguranca/Usuarios/UsuarioExtensaoAccess';
import UsuarioExtensaoCreate from './pages/Seguranca/Usuarios/UsuarioExtensaoCreate';
import UsuarioExtensaoEdit from './pages/Seguranca/Usuarios/UsuarioExtensaoEdit';
import UsuarioExtensaoView from './pages/Seguranca/Usuarios/UsuarioExtensaoView';
import UsuarioExtensaoBulkCreate from './pages/Seguranca/Usuarios/UsuarioExtensaoBulkCreate';

// Segurança - Perfis
import PerfilsList from './pages/Seguranca/Perfis/PerfilsList';
import PerfilCreate from './pages/Seguranca/Perfis/PerfilCreate';
import PerfilEdit from './pages/Seguranca/Perfis/PerfilEdit';
import PerfilView from './pages/Seguranca/Perfis/PerfilView';
import PerfilPermissoesBatch from './pages/Seguranca/Perfis/PerfilPermissoesBatch';

// Configurações
import CredencialConfigPage from './pages/Configuracoes/CredencialConfigPage';
import EmailConfigPage from './pages/Configuracoes/EmailConfigPage';

// Dashboard
import DashboardCoordenador from './pages/Dashboard/DashboardCoordenador';
import DashboardAdmin from './pages/Dashboard/DashboardAdmin';
// Relatórios
import RelatorioExtensoesSemPedidos from './pages/Relatorios/ExtensoesSemPedidos';

// Componente inteligente que redireciona para o dashboard correto.
// Regra de prioridade:
//   1. Permissão explícita `dashboard.admin.access` → Dashboard Administrativo
//   2. Coordenador (nível 2)                         → Dashboard do Coordenador
//   3. Demais                                        → tela genérica de boas-vindas
//
// A permissão `dashboard.admin.access` é criada pela migration
// backend/scripts/migrations-permissoes/01-add-dashboard-admin-permission.js
// e atribuída por padrão ao perfil "Super Admin".
const DashboardRouter = () => {
  const { user, hasPermission } = useAuth();

  if (hasPermission('dashboard.admin.access')) {
    return <DashboardAdmin />;
  }

  if (user?.nivel_acesso === 2) {
    return <DashboardCoordenador />;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Dashboard</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Bem-vindo ao sistema IBE!</p>
      </div>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <div>
        {/* Modal de aviso de inatividade - renderizado globalmente */}
        <InactivityWarningModal />
        
        <Routes>
          {/* Rotas públicas */}
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordForm />} />
          <Route path="/trocar-senha-obrigatoria" element={<TrocarSenhaObrigatoria />} />
          
          {/* Rotas protegidas */}
          <Route path="/" element={
            <ProtectedRoute>
              <BaseLayout />
            </ProtectedRoute>
          }>
            {/* Dashboard */}
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardRouter />} />
            
            {/* Meu Perfil */}
            <Route path="meu-perfil" element={<MeuPerfil />} />
            
            {/* Notificações */}
            <Route path="notificacoes" element={<NotificacoesPage />} />
            
            {/* Agendamentos WhatsApp */}
            <Route path="agendamentos-whatsapp" element={<AgendamentosWhatsAppPage />} />
            
            {/* Mural de Notícias */}
            <Route path="mural" element={<MuralNoticias />} />
            <Route path="mural/:id" element={<NoticiaView />} />
            <Route path="mural/gerenciar" element={
              <ProtectedRoute requiredPermission="noticias.list">
                <GerenciarNoticias />
              </ProtectedRoute>
            } />
            <Route path="mural/gerenciar/nova" element={
              <ProtectedRoute requiredPermission="noticias.create">
                <NoticiaForm />
              </ProtectedRoute>
            } />
            <Route path="mural/gerenciar/:id/editar" element={
              <ProtectedRoute requiredPermission="noticias.update">
                <NoticiaForm />
              </ProtectedRoute>
            } />
              
              {/* Alunos */}
              <Route path="alunos" element={
                <ProtectedRoute requiredPermission="alunos.list">
                  <AlunosList />
                </ProtectedRoute>
              } />
              <Route path="alunos/create" element={
                <ProtectedRoute requiredPermission="alunos.create">
                  <AlunoCreate />
                </ProtectedRoute>
              } />
              <Route path="alunos/:id/edit" element={
                <ProtectedRoute requiredPermission="alunos.update">
                  <AlunoEdit />
                </ProtectedRoute>
              } />
              <Route path="alunos/documentos-pendentes" element={
                <ProtectedRoute requiredPermission="alunos.update">
                  <DocumentosPendentes />
                </ProtectedRoute>
              } />
              
              {/* Protocolos de requerimento */}
              <Route path="protocolos" element={
                <ProtectedRoute requiredPermission="protocolos.list">
                  <ProtocolosList />
                </ProtectedRoute>
              } />
              <Route path="protocolos/novo" element={
                <ProtectedRoute requiredPermission="protocolos.create">
                  <ProtocoloCreate />
                </ProtectedRoute>
              } />
              <Route path="protocolos/:id/edit" element={
                <ProtectedRoute requiredPermission="protocolos.update">
                  <ProtocoloEdit />
                </ProtectedRoute>
              } />

              {/* Cursos */}
              <Route path="cursos" element={
                <ProtectedRoute requiredPermission="cursos.list">
                  <CursosList />
                </ProtectedRoute>
              } />
              <Route path="cursos/novo" element={
                <ProtectedRoute requiredPermission="cursos.create">
                  <CursoCreate />
                </ProtectedRoute>
              } />
              <Route path="cursos/:id/edit" element={
                <ProtectedRoute requiredPermission="cursos.update">
                  <CursoEdit />
                </ProtectedRoute>
              } />
              
              {/* Matrículas */}
              <Route path="matriculas" element={
                <ProtectedRoute requiredPermission="matriculas.list">
                  <MatriculasList />
                </ProtectedRoute>
              } />
              <Route path="matriculas/credenciais" element={
                <ProtectedRoute requiredPermission="matriculas.read">
                  <ImprimirCredenciais />
                </ProtectedRoute>
              } />
              
              {/* Colaboradores */}
              <Route path="colaboradores" element={
                <ProtectedRoute requiredPermission="colaboradores.list">
                  <ColaboradoresList />
                </ProtectedRoute>
              } />
              <Route path="colaboradores/create" element={
                <ProtectedRoute requiredPermission="colaboradores.create">
                  <ColaboradorCreate />
                </ProtectedRoute>
              } />
              <Route path="colaboradores/:id/edit" element={
                <ProtectedRoute requiredPermission="colaboradores.update">
                  <ColaboradorEdit />
                </ProtectedRoute>
              } />
              
              {/* Funcionários */}
              <Route path="funcionarios" element={
                <ProtectedRoute requiredPermission="funcionarios.list">
                  <FuncionariosList />
                </ProtectedRoute>
              } />
              <Route path="funcionarios/create" element={
                <ProtectedRoute requiredPermission="funcionarios.create">
                  <FuncionarioCreate />
                </ProtectedRoute>
              } />
              <Route path="funcionarios/:id/edit" element={
                <ProtectedRoute requiredPermission="funcionarios.update">
                  <FuncionarioEdit />
                </ProtectedRoute>
              } />
              
              {/* Contas */}
              <Route path="contas" element={
                <ProtectedRoute requiredPermissions={["financeiro.list", "contas.list"]}>
                  <ContasList />
                </ProtectedRoute>
              } />
              <Route path="contas/create" element={
                <ProtectedRoute requiredPermissions={["financeiro.create", "contas.create"]}>
                  <ContaCreate />
                </ProtectedRoute>
              } />
              <Route path="contas/:id/edit" element={
                <ProtectedRoute requiredPermissions={["financeiro.update", "contas.update"]}>
                  <ContaEdit />
                </ProtectedRoute>
              } />
              
              {/* Configurações */}
              <Route path="configuracoes/credenciais" element={
                <ProtectedRoute>
                  <CredencialConfigPage />
                </ProtectedRoute>
              } />
              <Route path="configuracoes/email" element={
                <ProtectedRoute>
                  <EmailConfigPage />
                </ProtectedRoute>
              } />
              
              {/* Pedidos */}
              <Route path="pedidos" element={
                <ProtectedRoute requiredPermission="pedidos.list">
                  <PedidosList />
                </ProtectedRoute>
              } />
              <Route path="pedidos/create" element={
                <ProtectedRoute requiredPermission="pedidos.create">
                  <PedidoCreate />
                </ProtectedRoute>
              } />
              <Route path="pedidos/:id/edit" element={
                <ProtectedRoute requiredPermission="pedidos.update">
                <PedidoEdit />
                </ProtectedRoute>
              } />
              <Route path="pedidos/cancelamentos" element={
                <ProtectedRoute requiredPermission="pedidos.approve_cancellation">
                  <GerenciarSolicitacoesCancelamento />
                </ProtectedRoute>
              } />

              {/* Relatórios */}
              <Route path="relatorios/extensoes-sem-pedidos" element={
                <ProtectedRoute requiredPermission="relatorios.extensoes_sem_pedidos.view">
                  <RelatorioExtensoesSemPedidos />
                </ProtectedRoute>
              } />

              {/* Estoque - Dashboard */}
              <Route path="estoque/dashboard" element={
                <ProtectedRoute requiredPermission="estoque.list">
                  <EstoqueDashboard />
                </ProtectedRoute>
              } />
              
              {/* Estoque - Relatório */}
              <Route path="estoque/relatorio" element={
                <ProtectedRoute requiredPermission="estoque.list">
                  <EstoqueRelatorio />
                </ProtectedRoute>
              } />
              
              {/* Estoque - Entrada de Material */}
              <Route path="estoque/entrada" element={
                <ProtectedRoute requiredPermission="estoque.list">
                  <EntradaMaterialList />
                </ProtectedRoute>
              } />
              <Route path="estoque/entrada/create" element={
                <ProtectedRoute requiredPermission="estoque.create">
                  <EntradaMaterialCreate />
                </ProtectedRoute>
              } />
              <Route path="estoque/entrada/:id/edit" element={
                <ProtectedRoute requiredPermission="estoque.update">
                  <EntradaMaterialEdit />
                </ProtectedRoute>
              } />
              
              {/* Produtos */}
              <Route path="produtos" element={
                <ProtectedRoute requiredPermission="produtos.list">
                  <ProdutoList />
                </ProtectedRoute>
              } />
              <Route path="produtos/create" element={
                <ProtectedRoute requiredPermission="produtos.create">
                  <ProdutoCreate />
                </ProtectedRoute>
              } />
              <Route path="produtos/:id/edit" element={
                <ProtectedRoute requiredPermission="produtos.update">
                  <ProdutoEdit />
                </ProtectedRoute>
              } />
              <Route path="produtos/precos-customizados" element={
                <ProtectedRoute requiredPermission="produtos.precos.listar">
                  <ProdutoPrecosCustomizados />
                </ProtectedRoute>
              } />
              
              {/* Tipo de Produto */}
              <Route path="tipo-produto" element={
                <ProtectedRoute requiredPermission="tipo_produto.list">
                  <TipoProdutoList />
                </ProtectedRoute>
              } />
              <Route path="tipo-produto/create" element={
                <ProtectedRoute requiredPermission="tipo_produto.create">
                  <TipoProdutoCreate />
                </ProtectedRoute>
              } />
              <Route path="tipo-produto/:id/edit" element={
                <ProtectedRoute requiredPermission="tipo_produto.update">
                  <TipoProdutoEdit />
                </ProtectedRoute>
              } />
              
              {/* Forma de Entrega */}
              <Route path="forma-entrega" element={
                <ProtectedRoute requiredPermission="forma_entrega.list">
                  <FormaEntregaList />
                </ProtectedRoute>
              } />
              <Route path="forma-entrega/create" element={
                <ProtectedRoute requiredPermission="forma_entrega.create">
                  <FormaEntregaCreate />
                </ProtectedRoute>
              } />
              <Route path="forma-entrega/:id/edit" element={
                <ProtectedRoute requiredPermission="forma_entrega.update">
                  <FormaEntregaEdit />
                </ProtectedRoute>
              } />
              
              {/* Forma de Pagamento */}
              <Route path="forma-pagamento" element={
                <ProtectedRoute requiredPermission="forma_pagamento.list">
                  <FormaPagamentoList />
                </ProtectedRoute>
              } />
              <Route path="forma-pagamento/create" element={
                <ProtectedRoute requiredPermission="forma_pagamento.create">
                  <FormaPagamentoCreate />
                </ProtectedRoute>
              } />
              <Route path="forma-pagamento/:id/edit" element={
                <ProtectedRoute requiredPermission="forma_pagamento.update">
                  <FormaPagamentoEdit />
                </ProtectedRoute>
              } />
              
              {/* Prazo de Entrega */}
              <Route path="prazo-entrega" element={
                <ProtectedRoute requiredPermission="prazo_entrega.list">
                  <PrazoEntregaList />
                </ProtectedRoute>
              } />
              <Route path="prazo-entrega/create" element={
                <ProtectedRoute requiredPermission="prazo_entrega.create">
                  <PrazoEntregaCreate />
                </ProtectedRoute>
              } />
              <Route path="prazo-entrega/:id/edit" element={
                <ProtectedRoute requiredPermission="prazo_entrega.update">
                  <PrazoEntregaEdit />
                </ProtectedRoute>
              } />
              
              {/* Extensões */}
              <Route path="extensoes" element={
                <ProtectedRoute requiredPermission="extensoes.list">
                  <ExtensoesList />
                </ProtectedRoute>
              } />
              <Route path="extensoes/create" element={
                <ProtectedRoute requiredPermission="extensoes.create">
                  <ExtensaoCreate />
                </ProtectedRoute>
              } />
              <Route path="extensoes/:id/edit" element={
                <ProtectedRoute requiredPermission="extensoes.update">
                  <ExtensaoEdit />
                </ProtectedRoute>
              } />
              
              {/* Financeiro - Contas a Pagar */}
              <Route path="financeiro/contas-pagar" element={
                <ProtectedRoute requiredPermission="financeiro.contas_pagar.list">
                  <ContasPagarList />
                </ProtectedRoute>
              } />
              <Route path="financeiro/contas-pagar/create" element={
                <ProtectedRoute requiredPermission="financeiro.contas_pagar.create">
                  <ContaPagarCreate />
                </ProtectedRoute>
              } />
              <Route path="financeiro/contas-pagar/:id/edit" element={
                <ProtectedRoute requiredPermission="financeiro.contas_pagar.update">
                  <ContaPagarEdit />
                </ProtectedRoute>
              } />
              <Route path="financeiro/contas-pagar/:id" element={
                <ProtectedRoute requiredPermission="financeiro.contas_pagar.read">
                  <ContaPagarView />
                </ProtectedRoute>
              } />
              
              {/* Financeiro - Despesas */}
              <Route path="financeiro/despesas" element={
                <ProtectedRoute requiredPermission="financeiro.despesas.list">
                  <DespesasList />
                </ProtectedRoute>
              } />
              <Route path="financeiro/despesas/create" element={
                <ProtectedRoute requiredPermission="financeiro.despesas.create">
                  <DespesaCreate />
                </ProtectedRoute>
              } />
              <Route path="financeiro/despesas/:id/edit" element={
                <ProtectedRoute requiredPermission="financeiro.despesas.update">
                  <DespesaEdit />
                </ProtectedRoute>
              } />
              <Route path="financeiro/despesas/:id" element={
                <ProtectedRoute requiredPermission="financeiro.despesas.read">
                  <DespesaView />
                </ProtectedRoute>
              } />
              
              {/* Financeiro - Receitas */}
              <Route path="financeiro/receitas" element={
                <ProtectedRoute requiredPermission="financeiro.receitas.list">
                  <ReceitasList />
                </ProtectedRoute>
              } />
              <Route path="financeiro/receitas/create" element={
                <ProtectedRoute requiredPermission="financeiro.receitas.create">
                  <ReceitaCreate />
                </ProtectedRoute>
              } />
              <Route path="financeiro/receitas/:id/edit" element={
                <ProtectedRoute requiredPermission="financeiro.receitas.update">
                  <ReceitaEdit />
                </ProtectedRoute>
              } />
              <Route path="financeiro/receitas/:id" element={
                <ProtectedRoute requiredPermission="financeiro.receitas.read">
                  <ReceitaView />
                </ProtectedRoute>
              } />
              
              {/* Acadêmico - Lançamento de Notas */}
              <Route path="academico/notas" element={
                <ProtectedRoute requiredPermission="academico.notas.list">
                  <LancamentoNotas />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Lançamento de Notas Individual */}
              <Route path="academico/lancamento-notas-individual" element={
                <ProtectedRoute requiredPermission="academico.notas.lancamento_individual.create">
                  <LancamentoNotasIndividual />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Histórico de Notas do Aluno */}
              <Route path="academico/historico-notas" element={
                <ProtectedRoute requiredPermission="academico.notas.read">
                  <HistoricoNotas />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Transferência de Notas entre Cursos */}
              <Route path="academico/transferencia-notas" element={
                <ProtectedRoute requiredPermission="academico.transferencia-notas.access">
                  <TransferenciaNotas />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Matriz Curricular - Listar */}
              <Route path="academico/matriz-curricular" element={
                <ProtectedRoute requiredPermission="matriz.list">
                  <MatrizCurricularList />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Matriz Curricular - Nova */}
              <Route path="academico/matriz-curricular/novo" element={
                <ProtectedRoute requiredPermission="matriz.create">
                  <MatrizCurricularForm />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Matriz Curricular - Editar Dados Básicos */}
              <Route path="academico/matriz-curricular/formulario/:id" element={
                <ProtectedRoute requiredPermission="matriz.update">
                  <MatrizCurricularForm />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Matriz Curricular - Editar (Módulos/Disciplinas) */}
              <Route path="academico/matriz-curricular/editar/:id" element={
                <ProtectedRoute requiredPermission="matriz.update">
                  <MatrizCurricularEdit />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Matriz Curricular - Visualizar */}
              <Route path="academico/matriz-curricular/visualizar/:id" element={
                <ProtectedRoute>
                  <MatrizCurricularEdit />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Progresso do Aluno - Com ID do Aluno */}
              <Route path="academico/matriz-curricular/:idMatriz/progresso/:idAluno" element={
                <ProtectedRoute requiredPermission="matriz.progresso.view">
                  <AlunoProgressoView />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Progresso do Aluno - Com idMatriz específico */}
              <Route path="academico/meu-progresso/:idMatriz" element={
                <ProtectedRoute>
                  <AlunoProgressoView />
                </ProtectedRoute>
              } />

              {/* Acadêmico - Meu Progresso - Redireciona para matrícula ativa */}
              <Route path="academico/meu-progresso" element={
                <ProtectedRoute>
                  <MeuProgressoRedirect />
                </ProtectedRoute>
              } />
              
              {/* Segurança - Usuários */}
              <Route path="seguranca/usuarios" element={
                <ProtectedRoute requiredPermission="usuarios.list">
                  <UsuariosList />
                </ProtectedRoute>
              } />
              <Route path="seguranca/usuarios/novo" element={
                <ProtectedRoute requiredPermission="usuarios.create">
                  <UsuarioCreate />
                </ProtectedRoute>
              } />
              <Route path="seguranca/usuarios/:id" element={
                <ProtectedRoute requiredPermission="usuarios.read">
                  <UsuarioView />
                </ProtectedRoute>
              } />
              <Route path="seguranca/usuarios/:id/editar" element={
                <ProtectedRoute requiredPermission="usuarios.update">
                  <UsuarioEdit />
                </ProtectedRoute>
              } />
              <Route path="seguranca/usuarios/extensoes" element={
                <ProtectedRoute requiredPermission="usuarios.read">
                  <UsuarioExtensaoAccess />
                </ProtectedRoute>
              } />
              <Route path="seguranca/usuarios/extensoes/create" element={
                <ProtectedRoute requiredPermission="usuarios.create">
                  <UsuarioExtensaoCreate />
                </ProtectedRoute>
              } />
              <Route path="seguranca/usuarios/extensoes/:id/edit" element={
                <ProtectedRoute requiredPermission="usuarios.update">
                  <UsuarioExtensaoEdit />
                </ProtectedRoute>
              } />
              <Route path="seguranca/usuarios/extensoes/:id" element={
                <ProtectedRoute requiredPermission="usuarios.read">
                  <UsuarioExtensaoView />
                </ProtectedRoute>
              } />
              <Route path="seguranca/usuarios/extensoes/bulk-create" element={
                <ProtectedRoute requiredPermission="usuarios.create">
                  <UsuarioExtensaoBulkCreate />
                </ProtectedRoute>
              } />

              {/* Segurança - Perfis */}
              <Route path="seguranca/perfis" element={
                <ProtectedRoute requiredPermission="perfis.list">
                  <PerfilsList />
                </ProtectedRoute>
              } />
              <Route path="seguranca/perfis/create" element={
                <ProtectedRoute requiredPermission="perfis.create">
                  <PerfilCreate />
                </ProtectedRoute>
              } />
              <Route path="seguranca/perfis/batch-permissions" element={
                <ProtectedRoute requiredPermission="perfis.update">
                  <PerfilPermissoesBatch />
                </ProtectedRoute>
              } />
              <Route path="seguranca/perfis/:id" element={
                <ProtectedRoute requiredPermission="perfis.read">
                  <PerfilView />
                </ProtectedRoute>
              } />
              <Route path="seguranca/perfis/:id/edit" element={
                <ProtectedRoute requiredPermission="perfis.update">
                  <PerfilEdit />
                </ProtectedRoute>
              } />
            </Route>
            
            {/* Rota catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </AuthProvider>
  );
}

export default App;
